const ONKO_URL =
  process.env?.REACT_APP_EXTERNAL_LINK_ONKOZBIORKA ??
  (process.env?.REACT_APP_MODE === "dev"
    ? "https://dev.onkomapa.pl"
    : "https://onkomapa.pl");
export const ONKO_URL_ADD_ONKOCOLLECTION = `${ONKO_URL}/zaloz-zbiorke`;
